import { Lightning } from '@lightningjs/sdk';
import { Seekbar } from './Seekbar';
import { PlayerButtonRow } from './PlayerButtonRow';

const Constants = {
  h: 240,
  Background: {
    colorTop: 0x00000000,
    colorBottom: 0xa1000000,
  },
  ButtonRow: {
    hDiff: 120,
  },
  Seekbar: {
    y: 120,
    hDiff: 120,
  },
};

export class Controls extends Lightning.Component {
  static _template() {
    return {
      h: Constants.h,
      w: w => w,
      BackgroundSeekbar: {
        y: h => h / 2,
        h: h => h / 2,
        w: w => w,
        rect: true,
        color: Constants.Background.colorBottom,
      },
      BackgroundButtons: {
        h: h => h / 2,
        w: w => w,
        rect: true,
        colorTop: Constants.Background.colorTop,
        colorBottom: Constants.Background.colorBottom,
      },
      ButtonRow: {
        type: PlayerButtonRow,
        h: h => h - Constants.ButtonRow.hDiff,
      },
      Seekbar: {
        type: Seekbar,
        y: Constants.Seekbar.y,
        h: h => h - Constants.Seekbar.hDiff,
      },
    };
  }

  static _states() {
    return [
      class Seekable extends this {
        _getFocused() {
          return this._seekbarFocused ? this.tag('Seekbar') : this.tag('ButtonRow');
        }
        _handleDown() {
          if (!this._seekbarFocused) {
            this._seekbarFocused = true;
          }
          return false;
        }
        _handleUp() {
          if (this._seekbarFocused) {
            this._seekbarFocused = false;
          }
          return false;
        }
      },
      class Unseekable extends this {
        _getFocused() {
          return this.tag('ButtonRow');
        }
      },
    ];
  }

  _init() {
    this._seekbarFocused = false;
  }

  /**
   * @param {PlayerController} playerController
   * @param {boolean} seekable
   */
  registerEventHandler(playerController, seekable) {
    this._playerController = playerController;
    this.tag('Seekbar').registerEventHandler(playerController, seekable);
    this.tag('ButtonRow').init(playerController);
    this.seekable = seekable;
  }

  _active() {
    if (this._playerController) {
      this.seekable = this._playerController.seekEnabled;
      this.tag('Seekbar').updateColors(this._playerController.seekEnabled);
    }
  }

  set seekable(value) {
    value ? this._setState('Seekable') : this._setState('Unseekable');
  }

  _handleLeft() {
    return false;
  }

  _handleRight() {
    return false;
  }

  _handleBack() {
    if (this._playerController.controlsManager._handleBack()) {
      this._seekbarFocused = false;
      return true;
    }
    return false;
  }

  _unfocus() {
    this._seekbarFocused = false;
  }

  focusSeekbar() {
    this._seekbarFocused = true;
  }

  focusButtons() {
    this._seekbarFocused = false;
  }

  _handlePlayPause() {
    return this._handleMedia();
  }

  _handlePlay() {
    return this._handleMedia();
  }

  _handlePause() {
    return this._handleMedia();
  }

  _handleRewind() {
    return this._handleMedia();
  }

  _handleForward() {
    return this._handleMedia();
  }

  _handleMedia() {
    this.focusButtons();
    return false;
  }
}
